import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import { DataListingRequestStatus, DataListingRequest } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class DataListingRequestsHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;

  public getAllRequestsDataListing(): Observable<DataListingRequest[]> {
    const url = `${this.API_URL}/data-listing-requests/`;
    return this.http.get<DataListingRequest[]>(url);
  }

  public getDataListingRequestsOfUser(payload: { userId: string }): Observable<DataListingRequest[]> {
    const url = `${this.API_URL}/data-listing-requests/${payload.userId}`;
    return this.http.get<DataListingRequest[]>(url);
  }

  public requestDataListing(): Observable<DataListingRequest> {
    const url = `${this.API_URL}/data-listing-requests/send-request`;
    return this.http.get<DataListingRequest>(url);
  }

  public changeDataListingRequestStatus(payload: {
    dataListingRequestId: string;
    status: DataListingRequestStatus;
  }): Observable<DataListingRequest> {
    const url = `${this.API_URL}/data-listing-requests/change-request-status`;
    return this.http.post<DataListingRequest>(url, payload);
  }
}
